import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {deprecatedTrackEvent} from 'analytics/Analytics';
import * as benchlingUtil from 'BenchlingUtil';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import BenchLink from 'link-preview/BenchLink';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {GetAnalyticsDashboard} from './details/graphql/__generated/GetAnalyticsDashboard';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

interface DashboardLinkProps {
  analyticsDashboard: Pick<AnalyticsDashboard, 'id' | 'name' | 'url'>;
  className?: string;
  showDashboardName?: boolean;
}

export default function DashboardLink({
  analyticsDashboard,
  className,
  showDashboardName = true,
}: DashboardLinkProps): JSX.Element {
  function handleTrackClickEvent(): void {
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.OPENED_DASHBOARD_FROM_EXTERNAL_MODULE);
  }

  return (
    <Tooltip title="Open original dashboard" placement={TooltipPlacement.BOTTOM}>
      <BenchLink
        className={classNames('u-display-inline-block', className)}
        href={benchlingUtil.pathToURL(analyticsDashboard.url)}
        fileId={analyticsDashboard.id}
      >
        <span>
          {showDashboardName && <span className="u-mini-spacing-right">{analyticsDashboard.name}</span>}
          <BenchlingIcon className={css(styles.smallLinkIcon)} icon="open" onClick={handleTrackClickEvent} />
        </span>
      </BenchLink>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  smallLinkIcon: {
    fontSize: '80%',
    transform: 'translateY(1px)',
  },
});
